import React from 'react';
import Button from 'react-bootstrap/Button';
import i18n from 'i18n';
import BzmIcon from '../icons/BzmIcon';
import FindReplaceRow from 'components/transactionEditor/FindReplaceRow';
import { getUniqueIndex } from 'components/transactionEditor/RequestMatchersList';

export interface FindReplaceItem {
  id: string;
  find: string | null;
  replace: string | null;
  location: string[] | null;
  [key: string]: string | string[] | null;
}

interface FindReplaceListProps {
  id: string;
  findReplaceList: FindReplaceItem[] | null;
  emptyListMessage: string;
  onListChange: (list: FindReplaceItem[]) => void;
  isReadOnly?: boolean;
}

const FindReplaceList = (props: FindReplaceListProps) => {
  const handleAddNew = () => {
    const emptyItem = {
      id: 'find-replace-item-' + getUniqueIndex(props.findReplaceList),
    } as FindReplaceItem;
    const list = props.findReplaceList ? props.findReplaceList.concat(emptyItem) : [emptyItem];
    props.onListChange(list);
  };

  const handleDelete = (id: string) => {
    if (props.findReplaceList) {
      const list = props.findReplaceList.filter((item: FindReplaceItem) => item.id !== id);
      props.onListChange(list);
    }
  };

  const handleChange = (name: string, value: string | string[], id: string) => {
    if (props.findReplaceList) {
      const list = [...props.findReplaceList];
      const index: number = list.findIndex(item => item.id === id);
      list[index][name] = value;
      props.onListChange(list);
    }
  };

  if (props.findReplaceList && props.findReplaceList.length > 0) {
    const length = props.findReplaceList.length;
    return (
      <div id={props.id}>
        {props.findReplaceList.map((item: FindReplaceItem, index: number) => (
          <FindReplaceRow
            isReadOnly={props.isReadOnly}
            onChange={handleChange}
            onAdd={handleAddNew}
            onDelete={() => handleDelete(item.id)}
            displayAdd={index === length - 1}
            key={item.id}
            id={item.id}
            findReplaceValues={item}
            index={index}
          />
        ))}
      </div>
    );
  }

  return (
    <div id={props.id}>
      <p>{props.emptyListMessage}</p>
      <Button
        id="qa-btn-find-replace-add-first"
        onClick={() => handleAddNew()}
        className="btn-circular"
        title={i18n.t('transactions:editor.addFindReplace')}
      >
        <BzmIcon variant={'icon-bzm-add'} />
      </Button>
    </div>
  );
};

export default FindReplaceList;
